/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.21.0
 * @since 1.14.0
 */

import { useFormikContext } from 'formik';
import InputMask from 'react-input-mask';

import { Input } from '@components/common';

import FormField, { IFormFieldProps } from './FormField';

interface IFormFieldInputPhone extends IFormFieldProps {
    mask: string;
}

const FormFieldInputPhone = (props: IFormFieldInputPhone) => {
    const { setFieldValue } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, kind, disabled, label, dataName, required }) => {
                return (
                    <Input
                        dataName={dataName}
                        disabled={disabled}
                        hintMessage={props.hintMessage}
                        kind={kind}
                        label={label}
                        required={required}
                    >
                        <InputMask
                            {...field}
                            disabled={disabled}
                            mask={props.mask}
                            placeholder={props.placeholder}
                            value={field.value}
                            onChange={event => setFieldValue(field.name, event.target.value.replace(/(\+7)|\D/g, ''))}
                        />
                    </Input>
                );
            }}
        </FormField>
    );
};

export default FormFieldInputPhone;
